
import { defineComponent } from "vue";
export default defineComponent({
  name: "CustomTitle",
  props: ["name", "description"],
});
